import { useState } from "react";
import { Building2 } from "lucide-react";
import { Badge, EmptyState, Page, Table, Text, type Column } from "@marekl/adminer/components";
import { useCompanies, type Company } from "../../lib/queries/companies";
import { ListCard } from "../../components/ListCard";
import { CompanyFormModal } from "./CompanyFormModal";

/** Every company of the instance (admin): founding one; a row opens its detail (legacy /companies/:id). */
export function CompaniesPage() {
  const companies = useCompanies();
  const [creating, setCreating] = useState(false);

  const columns: Column<Company>[] = [
    {
      key: "name",
      header: "Firma",
      primary: true,
      render: (c) => c.billing_details.business_name,
      linkTo: (c) => `/c/${c.id}/company`,
    },
    { key: "ico", header: "IČO", render: (c) => <Text variant="mono">{c.billing_details.ico || "—"}</Text> },
    {
      key: "vat",
      header: "DPH",
      render: (c) =>
        c.billing_details.vat_payer ? <Badge weight="ghost" variant="info">Plátce</Badge> : <Badge weight="ghost" variant="muted">Neplátce</Badge>,
    },
    { key: "city", header: "Sídlo", render: (c) => c.billing_details.city || "—" },
  ];

  return (
    <>
      <Page>
        <Page.Content>
          <ListCard title="Seznam společností" onCreate={() => setCreating(true)}>
            <Table<Company>
              cards
              columns={columns}
              rows={companies.data ?? []}
              rowKey={(c) => c.id}
              isLoading={companies.isLoading}
              error={companies.error}
              onRetry={companies.refetch}
              empty={<EmptyState icon={Building2} title="Zatím žádná firma" description="Založte první firmu, ve které budete vystavovat doklady." />}
            />
          </ListCard>
        </Page.Content>
      </Page>
      {creating && <CompanyFormModal onClose={() => setCreating(false)} />}
    </>
  );
}
